import { baseAPI_URL } from "@/services/api.service.js";
import { TokenService } from "@/services/storage.service.js";

export const dataTableOption = function(params) {
    return {
        "scrollX": true,
        "searching": true,
        "serverSide": true,
        "processing": true,
        "searchHighlight": true,
        "searchDelay": 1000,
        // "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]]
        "dom": "<'row'<'col-md-12'B>><'row'<'col-md-6'l><'col-md-6'f>><'row'<'col-md-12't>><'row'<'col-md-6'i><'col-md-6'p>>",
        "buttons": [
            { extend: "csv", className: "exportButtons", title: params.exportTitle }, 
            { extend: "excel", className: "exportButtons", title: params.exportTitle }, 
            // { extend: 'pdf', className: 'exportButtons', title: params.exportTitle}
        ],
        "ajax": {
            "type": "GET",
            "dataType": "json",
            "url": baseAPI_URL + "/api/services/app/" + params.ajax.url,
            "headers": {
                "Authorization": "Bearer " + TokenService.getToken()
            },
            "data": function(data) {
                data.SkipCount = data.start;
                data.MaxResultCount = data.length;
                data.Filter = data.search.value;

                if (params.data) {
                    Object.keys(params.data).forEach(function (key) {
                        data[key] = params.data[key];
                    });
                }

                if (params.dataArray) {
                    Object.keys(params.dataArray).forEach(function (key) {
                        data[key] = params.dataArray[key];
                    });
                }
                if (params.sorting) {
                    data.Sorting = params.sorting;
                }
                else {
                    var order = data.order[0].dir;
                    var orderColumn = data.order[0].column;
                    var orderName = data.columns[orderColumn].data;
                    data.Sorting = orderName + " " + order;
                }

		         //Remove unnecessary AJAX parameters!
		         delete data.columns, delete data.order, delete data.search, delete data.start, delete data.length;
		    },
            "dataSrc": "result.items",
            "dataFilter": function(dataFilter) {
		     	var json = jQuery.parseJSON( dataFilter );
		     	json.recordsTotal = json.result.totalCount;
		     	json.recordsFiltered = json.result.totalCount;
			        return JSON.stringify( json ); // return JSON string
            },
            error: function (xhr, error, code)
            {
            	EventBus.$emit("snackBar", {
		  		  text: xhr.responseJSON.error.message,
		  		  snackbarColor: "red lighten-1"
		  		});
            }
        },
        "order": params.order,
        "columnDefs": params.columnDefs,
        "columns": params.columns,
	   	"select": {
	   		"style": "multi",
	   		"selector": "td:first-child"
        },
        "pageLength": params.pageLength ? params.pageLength : 10,
        "initComplete": params.initComplete,
        "drawCallback": params.drawCallback
    };
};

export const dataTableOption_noSearch = function(params) {
    return {
        "scrollX": true,
        "searching": true,
        "serverSide": true,
        "processing": true,
        "searchHighlight": true,
        "searchDelay": 1000,
        "ajax": {
            "type": "GET",
            "dataType": "json",
            "url": baseAPI_URL + "/api/services/app/" + params.ajax.url,
            "headers": {
                "Authorization": "Bearer " + TokenService.getToken()
            },
            "data": function(data) {
                data.SkipCount = data.start;
                data.MaxResultCount = data.length;
                data.Filter = data.search.value;

                if (params.data) {
                    Object.keys(params.data).forEach(function (key) {
                        data[key] = params.data[key];
                    });
                }

		         // Sorting varible
		         var order = data.order[0].dir;
		         var orderColumn = data.order[0].column;
		         var orderName = data.columns[orderColumn].data;
		         data.Sorting = orderName + " " + order;

		         //Remove unnecessary AJAX parameters!
		         delete data.columns, delete data.order, delete data.search, delete data.start, delete data.length;
		    },
		     "dataSrc": "result.items",
		     "dataFilter": function(dataFilter) {
		     	var json = jQuery.parseJSON( dataFilter );
		     	json.recordsTotal = json.result.totalCount;
		     	json.recordsFiltered = json.result.totalCount;
			        return JSON.stringify( json ); // return JSON string
            },
        },
        "columnDefs": params.columnDefs,
        "columns": params.columns,
	   	"select": {
	   		"style": "multi",
	   		"selector": "td:first-child"
	   	},	
    };
};


// WEBPACK FOOTER //
// ./src/assets/js/dataTable/dataTable-options.js